<template>
  <div>
    <div class="content">
      <LoginLogo />

      <v-container>
        <v-row>
          <v-col>
            <div class="bg-success" v-if="successMessage">
              {{successMessage}}
            </div>

            <div class="bg-error" v-if="errorMessage">
              {{errorMessage}}
            </div>
          </v-col>
        </v-row>
      </v-container>

    </div>

    <!-- <div class="text-center mt-5">
      <router-link to="/account/login">Go to the login page</router-link>
    </div> -->
  </div>
</template>

<script>
import { useSystemStore } from '@/stores/SystemStore.js'
import LoginLogo from '../account/components/LoginLogo.vue'

export default {
  name: 'ValidateTenantEmail',
  components: {
    LoginLogo,
  },
  data: function() {
    return {
      code: '',
      tenantId: '',

      errorMessage: '',
      successMessage: '',
    }
  },
  mounted: function() {
    this.tenantId = this.$route.query.id || '';
    this.code = this.$route.query.code || '';

    // console.log(this.$route);

    if (!this.tenantId || !this.code) {
      this.errorMessage = "This link is invalid!";
      return;
    }

    let self = this;
    const payload = {
      id: this.tenantId,
      code: this.code,
    };

    const systemStore = useSystemStore();
    systemStore.validateTenantEmail(payload)
    .then(function(response) {
      if (response && response.data && response.data.message) {
        self.successMessage = response.data.message;
      }
    })
    .catch(function(error) {
      if (error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message) {
            self.errorMessage = error.response.data.error.message;
          } else {
            self.errorMessage = "Error!";
          }
    });
  }
}
</script>
